// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3p-dY","range":"MonthRangeSwitch_range__Z5Aem","disabled":"MonthRangeSwitch_disabled__1E2Rq"};